import React from 'react'

import TeamBut from '../Components/TeamBut/TeamBut';
import OurTeam from '../Components/OurTeam/OurTeam';
import Newsletter from '../Components/Newsletter/Newsletter';

const Homepage = () => {
  return (
    <div>
       
       <OurTeam />
       <TeamBut/>
       <Newsletter/>
       
    </div>
  )
}

export default Homepage
